import React, { FC } from 'react';
import { t } from '@lingui/macro';

import getBrandSpecificValue from '@rover/shared/js/utils/getBrandSpecificValue';
import { PetType } from '@rover/types/src/Pet';

import { getSearchFiltersFromSeoLocationDetails } from '../utilities';

import SeoLocationHowBrandWorks from './components/HowBrandWorks';
import SeoLocationReviewsCarousel from './components/SeoLocationReviewsCarousel';
import {
  SeoLocationFooterLinks,
  SeoLocationPageWrapper,
  SeoLocationRoverProtect,
} from './components';
import { SeoLocationPageProps } from './types';

const getHeaderForReviewsCarousel = (petType, brandDisplayName, locationName) => {
  const dogSpecific = t`Dog parents share their ${brandDisplayName} experiences - ${locationName}`;
  const catSpecific = t`Cat parents share their ${brandDisplayName} experiences - ${locationName}`;
  const puppySpecific = t`Puppy parents share their ${brandDisplayName} experiences - ${locationName}`;
  const generic = t`Pet parents share their ${brandDisplayName} experiences - ${locationName}`;

  switch (petType) {
    case PetType.CAT:
      return catSpecific;
    case PetType.DOG:
      return dogSpecific;
    case PetType.PUPPY:
      return puppySpecific;
    default:
      return generic;
  }
};

const SeoLocationPageTemplate: FC<SeoLocationPageProps> = ({
  seoLocation,
  countryConfig,
  frontendConfig,
  reviews,
}) => {
  const { linkedLocations, details } = seoLocation;
  const { language } = frontendConfig.settings;
  const initialSearchFilters = getSearchFiltersFromSeoLocationDetails(seoLocation);
  const {
    cityName,
    breadcrumbData,
    relatedServices,
    serviceTypeName,
    petType,
    name: locationName,
  } = details;
  const brandDisplayName = getBrandSpecificValue({
    rover: 'Rover',
    catInAFlat: 'Cat in a Flat',
  });

  return (
    <SeoLocationPageWrapper seoLocation={seoLocation} countryConfig={countryConfig}>
      <SeoLocationReviewsCarousel
        seoLocation={seoLocation}
        reviews={reviews}
        searchFilters={initialSearchFilters}
        language={language}
        header={getHeaderForReviewsCarousel(petType, brandDisplayName, locationName)}
      />
      <SeoLocationHowBrandWorks
        serviceTypeName={serviceTypeName}
        petType={(petType as PetType) ?? undefined}
        brandDisplayName={brandDisplayName}
      />
      <SeoLocationRoverProtect my={['8x', '16x']} />
      <SeoLocationFooterLinks
        breadcrumbData={breadcrumbData}
        serviceName={serviceTypeName}
        locationName={cityName}
        linkedLocations={linkedLocations}
        relatedServices={relatedServices}
        brandDisplayName={brandDisplayName}
      />
    </SeoLocationPageWrapper>
  );
};

export default SeoLocationPageTemplate;
